<template>
	<div class="container-fluid px-lg-2 px-xl-4">
        <!-- Encabezado de ubicación (Breadcum)-->
		<div class="row d-flex align-items-center">
			<div class="col-12 col-sm-7 pl-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Estatus de pedidos</li>
					</ol>
				</nav>
			</div>
		</div>       
        
        <!-- pedidos activos -->
        <div class="row bg-white etiqueta-pedidos p-1 mb-2 text-center text-lg-left">
            <div class="col-6 p-1 my-2 text-center text-lg-left">Pedidos activos</div>
            <div class="col-6 d-flex align-items-center justify-content-end">
                    <span   class="fuenteestatussm ColorAzul seleccionado-signo" >
                            PRESIONE
                            <span class="badge-signo-sm fas fa-question-circle"/>
                    </span>
                    <span class="ml-4 fuenteestatussm ColorAzul font18">PARA SABER MÁS SOBRE EL ESTATUS</span>
            </div>
        </div>
        <!-- tabla sm, md -->
        <div class="d-block d-lg-none">
            <div class="row">
                <table class="font-13 table  table-sm">
                       <thead class="tabla-activos">
                           <tr class="text-white">
                            <th class="text-center p-2 vertical-align-center">CEDIS</th>
                            <th class="text-center p-2 vertical-align-center">Folio</th>
                            <th class="text-center p-2 vertical-align-center">Origen</th>
                            <th class="text-center p-2 vertical-align-center">Fecha y Hora de <br> realización de pedido</th>
                        </tr>
                       </thead>  
                       <tbody>
                        <tr @click="detalle(item)" 
                            v-bind:key="item.folio" 
                            v-for="item in pedidosActivos" 
                            class="bg-white font-15 ColorAzul"
                            style="height:50px">
                           <td class="text-center align-top sinbordes">
                                <div class="row">
                                    <div class="col-12 mb-4 align-top">{{item.cedis}}</div>
                                    <div class="col-12 text-warning align-middle ">
                                        <div class="fuenteestatussm" v-if="estatus(item.estatus) != 2" >
                                            {{estatusDesc(item.estatus)}}
                                        </div>
                                        <div class="col-12" v-else>
                                            <span @click.stop="" class="fuenteestatussm seleccionado-signo" 
                                                    :title="item.estatusMensaje"
                                                    v-b-tooltip.hover>
                                                {{estatusDesc(item.estatus)}}
                                                <i @click.stop=""   v-if="item.estatusMensaje != ''" 
                                                        class="badge-signo-sm fas fa-question-circle"/>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-12 fuentesm">
                                        <span   @click.stop=""
                                                :title="estatus(item.estatus) != 2?'':item.estatusMensaje"
                                                v-b-tooltip.hover>
                                            ESTATUS
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center align-top">  
                                <div class="row">
                                    {{item.folio}}
                                </div> 
                            </td>
                            <td class="align-top text-center justify-content-center">
                                <div class="row text-center justify-content-center">
                                    <div class="text-center justify-content-center">
                                        {{item.origen}}
                                    </div>
                                </div>    
                            </td>
                            <td class="text-center align-top">
                                <div class="row">
                                    <div class="col-12 mb-4">{{item.fechaRecepcion | format-date('DD/MMM/YYYY')}} {{item.fechaRecepcion | format-date('HH:mm')}} hrs</div>
                                    <!-- <div class="col-12 text-warning">
                                        <div class="fuenteestatussm">
                                            ...
                                        </div>
                                    </div>
                                    <div class="col-12 ColorAzul fuentesm">
                                        FECHA ESTIMADA DE ENTREGA
                                    </div> -->
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- tabla lg, xl -->
        <div class="row d-none d-lg-block">
            <div>
                <table class="fuente-tablas table tabla-activos table-sm">
                    <thead>
                        <tr class="text-white">
                            <th class="ocultar"></th>
                            <th class="ocultar"></th>
                            <th class="ocultar"></th>
                            <th class="ocultar"></th>
                            <th class="text-center bg-white ColorAzul" colspan="7">Estatus</th>
                            <!-- <th class="ocultar"></th> -->
                        </tr>
                        <tr class="text-white">
                            <th class="text-center p-2 align-middle">CEDIS</th>
                            <th class="text-center p-2 align-middle">Folio</th>
                            <th class="text-center p-2 align-middle">Medio</th>
                            <th class="text-center p-2 align-middle">Fecha y Hora de <br> recepción</th>
                            <th class="text-center p-2 align-middle">En revisión</th>
                            <th class="text-center p-2 align-middle">Detenido</th>
                            <th class="text-center p-2 align-middle">Validando <br> Condiciones</th>
                            <th class="text-center p-2 align-middle">Surtiéndose</th>
                            <th class="text-center p-2 align-middle">Empacándose</th>
                            <th class="text-center p-2 align-middle">Listo para <br> enviar</th>
                            <th class="text-center p-2 align-middle">Enviado</th>
                            <!-- <th class="text-center p-2">Fecha estimada de entrega</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr @click="detalle(item)" 
                            v-bind:key="item.folio" 
                            v-for="item in pedidosActivos" 
                            class="bg-white"
                            style="height:50px">
                            <td class="text-center align-middle ColorAzul">
                                <div class="">{{item.cedis}}</div>
                            </td>
                            <td class="text-center align-middle ColorAzul">
                                <div class="">{{item.folio}}</div>
                            </td>
                            <td class="text-center align-middle ColorAzul">
                                <div class="">{{item.origen}}</div>
                            </td>
                            <td class="text-center align-middle ColorAzul">
                                <div class="">{{item.fechaRecepcion | format-date('DD/MMM/YYYY')}} {{item.fechaRecepcion | format-date('HH:mm')}} hrs</div>
                            </td>
                            <td class="text-center align-middle p-0">                                
                                <Progress class="" col="1" :paso="estatus(item.estatus)"></Progress>
                            </td>
                            <td class="text-center align-middle p-0">                                
                                <Progress class="" col="2" :paso="estatus(item.estatus)" :mensaje="item.estatusMensaje"></Progress>
                            </td>
                            <td class="text-center align-middle p-0">                                
                                <Progress class="" col="3" :mensaje="item.estatusMensaje" :paso="estatus(item.estatus)"></Progress>
                            </td>
                            <td class="text-center align-middle p-0">                                
                                <Progress class="" col="4" :paso="estatus(item.estatus)"></Progress>
                            </td>
                            <td class="text-center align-middle p-0">                                
                                <Progress class="" col="5" :paso="estatus(item.estatus)"></Progress>
                            </td>
                            <td class="text-center align-middle p-0">                                
                                <Progress class="" col="6" :paso="estatus(item.estatus)"></Progress>
                            </td>
                            <td class="text-center align-middle p-0">                                
                                <Progress class="" col="7" :paso="estatus(item.estatus)"></Progress>
                            </td>
                            <!-- <td>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> 

        <!-- pedidos anteriores --> 
        <div class="row bg-white mb-2" ref="ancla">
            <div class="col-12 etiqueta-pedidos p-1 my-2 text-center text-lg-left">Pedidos anteriores</div>
            <div class="col-12">
                <div class="row">
                    <div class="col-6 col-md-2">
                        <span class="etiqueta-fecha">Desde:</span>
                    </div>
                    <div class="col-6 col-md-2">
                        <span class="etiqueta-fecha">Hasta:</span>
                    </div>
                </div>
                <div class="row mb-2 d-flex align-items-center">
                    <div class="col-6 col-md-2 mb-2">
                        <datepicker
                            :format="format"
                            :language="languages['es']"
                            input-class="form-control form-control-sm font-12 bg-white"
                            placeholder="Select Date"
                            v-model="fechaInicio"
                            wrapper-class="borderAzul"
                        />
                    </div>
                    <div class="col-6 col-md-2 mb-2">
                        <datepicker
                            :format="format"
                            :language="languages['es']"
                            input-class="form-control form-control-sm font-12 bg-white"
                            placeholder="Select Date"
                            v-model="fechaFin"
                            wrapper-class="borderAzul"
                        />
                    </div>
                    <div class="col-12 col-md-2 mb-2">
                        <button class="btn borderAzul ColorAzul font-12 ButtonConsultar" 
                                @click="consultar">
                            Consultar
                        </button>
                    </div>
                </div>
            </div> 
        </div>        

        <!-- tabla sm, md -->
        <div class="d-block d-lg-none">
            <div class="row">
                <table class="font-13 table tabla-activos table-sm">
                       <thead>
                           <tr class="text-white">
                            <th class="text-center p-2 vertical-align-center">CEDIS</th>
                            <th class="text-center p-2 vertical-align-center">Folio</th>
                            <th class="text-center p-2 vertical-align-center">Origen</th>
                            <th class="text-center p-2 vertical-align-center">Fecha y Hora de <br> realización de pedido</th>
                        </tr>
                       </thead>  
                       <tbody>
                        <tr @click="detalle(item)" 
                            v-bind:key="item.folio" 
                            v-for="item in pedidosAnteriores" 
                            class="bg-white font-15"
                            style="height:50px">
                            <td class="text-center ColorAzul sinbordes">
                                <div class="row">
                                    <div class="col-12 mb-4 align-top">{{item.cedis}}</div>
                                    <div class="col-12 align-middle ">
                                        <div class="fuenteestatussm text-success font-weight-bold" v-if="item.estatus.trim() == 'B'" >
                                            ENVIADO
                                        </div>
                                        <div v-else>
                                            <span   @click.stop=""
                                                    class="text-danger seleccionado-signo font-weight-bold fuenteestatussm" 
                                                    :title="item.estatusMensaje"
                                                    v-b-tooltip.hover>
                                                CANCELADO
                                                <i @click.stop=""   v-if="item.estatusMensaje != ''" 
                                                        class="badge-signo-sm fas fa-question-circle"/>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-12 ColorAzul fuentesm">
                                        <span   @click.stop=""
                                                :title="item.estatusMensaje"
                                                v-b-tooltip.hover>
                                            ESTATUS
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center align-top ColorAzul">   
                                {{item.folio}}
                            </td>
                            <td class="text-center align-top ColorAzul">
                                {{item.origen}}
                            </td>
                            <td class="text-center align-top ColorAzul">
                                <div class="row">
                                    <div class="col-12 mb-4">{{item.fechaRecepcion | format-date('DD/MMM/YYYY')}} {{item.fechaRecepcion | format-date('HH:mm')}} hrs</div>
                                    <!-- <div class="col-12 text-warning">
                                        <div class="fuenteestatussm">
                                            ...
                                        </div>
                                    </div>
                                    <div class="col-12 ColorAzul fuentesm">
                                        FECHA ESTIMADA DE ENTREGA
                                    </div> -->
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- tabla lg, xl -->
        <div class="row d-none d-lg-block">
            <div>
                <table class="table tabla-activos table-sm fuente-tablas mt-2">
                    <thead>
                        <!-- <tr class="text-white">
                            <th class="ocultar"></th>
                            <th class="ocultar"></th>
                            <th class="ocultar"></th>
                            <th class="ocultar"></th>
                            <th class="text-center bg-white ColorAzul" colspan="7">Estatus</th>
                        </tr> -->
                        <tr class="text-white">
                            <th class="text-center p-2 align-middle">CEDIS</th>
                            <th class="text-center p-2 align-middle">Folio</th>
                            <th class="text-center p-2 align-middle">Medio</th>
                            <th class="text-center p-2 align-middle">Fecha y Hora de <br> recepción</th>
                            <th class="text-center p-2 align-middle">Estatus</th>
                            <!-- <th class="text-center p-2 align-middle">Detenido</th>
                            <th class="text-center p-2 align-middle">Validando <br> Condiciones</th>
                            <th class="text-center p-2 align-middle">Surtiéndose</th>
                            <th class="text-center p-2 align-middle">Empacándose</th>
                            <th class="text-center p-2 align-middle">Listo para <br> enviar</th> -->
                            <th class="text-center p-2 align-middle">Enviado</th>
                            <!-- <th class="text-center p-2">Fecha estimada de entrega</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr @click="detalle(item1)" 
                            v-bind:key="item1.folio" 
                            v-for="item1 in pedidosAnteriores" 
                            class="bg-white" >
                            <td class="text-center align-middle ColorAzul">
                                <div class="">{{item1.cedis}}</div>
                            </td>
                            <td class="text-center align-middle ColorAzul">
                                <div class="">{{item1.folio}}</div>
                            </td>
                            <td class="text-center align-middle ColorAzul">
                                <div class="">{{item1.origen}}</div>
                            </td>
                            <td class="text-center align-middle ColorAzul">
                                <div class="">{{item1.fechaRecepcion | format-date('DD/MMM/YYYY')}} {{item1.fechaRecepcion | format-date('HH:mm')}} hrs</div>
                            </td>
                            <td class="text-center align-middle p-0">
                                <div v-if="item1.estatus.trim() == 'B'" >
                                    <span   class="fuente-texto text-success font-weight-bold">
                                            Enviado
                                    </span>
                                </div>
                                <div v-else>
                                    
                                    <span  class="fuente-texto text-danger seleccionado-signo font-weight-bold" 
                                        :title="item1.estatusMensaje"
                                        v-b-tooltip.hover>
                                        Cancelado
                                        <span v-if="item1.estatusMensaje != ''" class="badge-signo fas fa-question-circle"/>
                                    </span>
                                </div>                                
                            </td>
                            <td class="text-center align-middle p-0">
                                <div v-if="item1.estatus.trim() == 'B'" >
                                    <img
                                        class="tamano-icono"
                                        src="@/assets/img-priv/palomita.png"/>
                                    <!-- <i  class="far fa-check-circle bg-success circulo"></i> -->
                                </div>
                                <div v-else>
                                    <img
                                        class="tamano-icono"
                                        src="@/assets/img-priv/x.png"/>
                                    <!-- <i  class="far fa-times-circle bg-danger circulo"></i> -->
                                </div>
                            </td>
                            <!-- <td>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> 

        <!-- paginador -->
        <div class="row">
            
            <div class="col-12 pt-3 d-flex justify-content-center">
                <ul class="pagination">
                    <li class="page-item" v-show="paginaActual > 1">
                        <a  @click="navegar(1)" 
                            class="page-link" 
                            role="button">«</a>
                    </li>
                    <li class="page-item">
                        <a
                            @click="navegar(paginaActual-1)"
                            class="page-link text-decoration-none d-none d-md-block"
                            role="button"
                            v-if="paginaActual > 1 && pedidosAnteriores != null"
                        >Anterior</a>
                    </li>
                    <li :class="{active: paginaActual == pag}" 
                        :key="pag" 
                        class="page-item" 
                        v-for="pag in paginador">
                        <a  @click="navegar(pag)"
                            class="page-link">{{pag}}</a>
                    </li>
                    <li class="page-item" 
                        v-if="pedidosAnteriores != null && pedidosAnteriores.length > 0 && paginaActual < totalPaginas">
                        <a  @click="navegar(paginaActual+1)" 
                            class="page-link text-decoration-none d-none d-md-block" 
                            role="button">Siguiente</a>
                    </li>
                    <li class="page-item" 
                        v-show="paginaActual < totalPaginas">
                        <a  @click="navegar(totalPaginas)" 
                            class="page-link" 
                            role="button">»</a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Modales -->
        <b-modal id="modal-scrollable" size="xl" >
            <!-- @shown="onShownModal" -->
			<template>
				<div>
					<div class="d-flex font-size-14 font-open-sans text-white cabecera-bg">
						<span class="my-2 ml-1">Detallado del pedido: {{ folio }} - {{ origen }}</span>
						<span class="my-2 ml-auto mr-1">{{ fecha | format-date('DD/MMM/YYYY') }}</span>
					</div>
					<div class="table-responsive tabla-detalle-wrapper" style="height: 500px;">
						<table class="table table-bordered table-sm" ref="tabla-detalle">
							<thead class="cabecera-tabla font-open-sans">
								<tr class="color-azul">
									<th class="font-semi-bold">Descripci&oacute;n</th>
									<th class="d-none d-md-table-cell text-right font-semi-bold border">Cantidad</th>
									<th class="d-none d-md-table-cell text-right font-semi-bold">Surtido</th>
									<th
										:class="{'d-md-table-cell': mostrarNegados}"
										class="d-none text-right font-semi-bold"
									>Negado</th>
								</tr>
							</thead>
							<tbody class="bg-white color-azul">
								<tr name="item.folio" v-bind:key="item.folio" v-for="item in itemsDetalle">
									<th class="text-left">
										<div class="font-size-14 font-open-sans font-semi-bold color-azul">{{item.descripcion}}</div>
										<div
											class="d-block d-md-none font-size-12 font-open-sans font-semi-bold color-azul ml-1"
											v-if="estatusPedido=='B'"
										>
											<span class="mr-1">Surtido: {{item.cantidadSurtida | format-number("0,0")}}</span>
											<span>Negado: {{item.cantidadNegada | format-number("0,0")}}</span>
										</div>
										<div
											class="d-block d-md-none font-size-12 font-open-sans font-semi-bold color-azul ml-1"
											v-if="estatusPedido!='B'"
										>
											<span class="mr-1">Cantidad: {{item.cantidadPedida | format-number("0,0")}}</span>
											<span>Surtido: {{item.cantidadSurtida | format-number("0,0")}}</span>
										</div>
									</th>
									<th class="d-none d-md-table-cell">
										<div
											class="font-size-14 text-right font-open-sans color-azul mr-2"
										>{{item.cantidadPedida | format-number("0,0")}}</div>
									</th>
									<th class="d-none d-md-table-cell">
										<div
											class="font-size-14 text-right font-open-sans color-azul mr-2"
											v-show="item.cantidadSurtida > 0"
										>{{item.cantidadSurtida | format-number("0,0")}}</div>
									</th>
									<th :class="{'d-md-table-cell': mostrarNegados}" class="d-none font-size-14 text-right">
										<span v-show="item.cantidadNegada > 0">{{item.cantidadNegada | format-number("0,0")}}</span>
									</th>
								</tr>
							</tbody>
						</table>
					</div>
                    <div class="font-open-sans color-azul rows">
                        <div class="row">
                            <div class="col-6 m-1">
                                <span>Renglones: {{renglonesPedido}}</span>
                            </div>
                            <div class="col-5 m-1 text-right">
                                <span>Artículos: {{totalArticulos}}</span>
                            </div>
                        </div>
                    </div>
				</div>
			</template>
		</b-modal>
        <!--Fin modales -->
	</div>
</template>
<script>
	import servicio from "@/services/servicio-estatus-pedido"
	import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
	import * as lang from "vuejs-datepicker/src/locale"
    import Progress from "@/components/clientes/EstatusPedidoProgress"

	//import Swal from "sweetalert2"
	//import moment from "moment"

	export default {
		components: {
			Datepicker,
            Progress,
		},
		data() {
			return {
                pedidosActivos: [],
				pedidosAnteriores: [],
                ordenActivos:0,
                paso:0,
				fechaInicio: new Date(),
				fechaFin: new Date(),
				languages: lang,
                format: "dd/MMM/yyyy",
                itemsDetalle:[],
                folio:0,
                origen:'',
                fecha:'',
                estatusPedido: "",
                mostrarNegados: false,
                registrosxpagina:50,
                paginaActual:1,
                totalPaginas:1,
                paginador:[]
			}
		},
		async mounted() {
            await this.inicializar()
            await this.pedidosActivosCon()
            this.getPedidosAnteriores()
            this.carritoConsultarCantidad()
        },
        computed:{
            renglonesPedido(){
                return this.itemsDetalle.length
            },
            totalArticulos(){
                //let sum = 0;
                var total = 0;
                this.itemsDetalle.forEach(item => {
                    total += item.cantidadPedida;
                });
                return total// this.itemsDetalle.map(function( x ){ sum += x.cantidadPedida})
                //return this.itemsDetalle.sum('cantidadPedida')
            }
        },
		methods: {
            consultar(){
                this.paginaActual = 1
                this.getPedidosAnteriores()
            },
            navegar(pag){
                this.paginaActual = pag
                this.getPedidosAnteriores()
                this.scrollMeTo('ancla')
            },
            paginas() {
				const pagina = Number(this.paginaActual)
				const totPaginas = Number(this.totalPaginas)
                
                //console.log('totPaginas, pagina', totPaginas,pagina)
				if (pagina == null || totPaginas == null) return []

				let res = []
				const max = 5
				let aux = Math.floor(max / 2)

				let inicio = pagina - aux > 0 ? pagina - aux : 1

				let fin = pagina + aux > totPaginas ? totPaginas : pagina + aux

				for (let i = inicio; i <= fin; i++) {
					res.push(i)
				}

				this.paginador = res
			},
            getPedidosAnteriores(){
                //console.log('tag', this.fechaInicio, this.fechaFin, this.registrosxpagina,this.paginaActual)
                //this.paginaActual = 1
                this.$loading(true)
                servicio.getPedidosAnteriores(this.fechaInicio, this.fechaFin, this.registrosxpagina,this.paginaActual)
                    .then(r => {
                        this.$loading(false)
                        this.pedidosAnteriores = r.data.lisConfirmacionPedidosEnc
                        this.totalPaginas = r.data.totalPaginas
                        this.paginas()
                        //console.log('tag', r.data)
                    })
                    .catch( err => {
                        this.$loading(false)
                        console.log('tag', err)
                    })
            },
            detalle(item) {
                //console.log('item', item)
                this.folio = item.folio
                this.origen = item.origen
                this.fecha = item.fecha
                this.estatusPedido = item.estatus
				this.mostrarNegados = item.estatus == "B"
                this.itemsDetalle=[]
				servicio.getDetallePedido(item.folio)
					.then(r => {
						//console.log(r.data)
                        this.itemsDetalle = r.data
                        this.$bvModal.show('modal-scrollable')
					})
					.catch(err => {
						console.error(err)
					})
            },
            estatusDesc(e){
                var estatus=''
                
                switch (e) {
                case 'R': //recibido
                    estatus='EN REVISÓN' //en revision
                    break;
                case 'D': //detenido
                    estatus='EN REVISÓN' //en revision
                    break;
                case 'DP': //detenido por precio especial
                    estatus='EN REVISÓN' //en revision
                    break;
                case 'DC': //detenido credito a un dia
                    estatus='EN REVISÓN' //en revision
                    break;
                case 'DL': //detenido limite de credito
                    estatus='EN REVISÓN' //en revision
                    break;
                case 'DD': //detenido cheque devuelto
                    estatus='EN REVISÓN' //en revision
                    break;
                case 'DA': //detenido agrupacion
                    estatus='EN REVISÓN' //en revision
                    break;
                case 'N': //no autorizado
                    estatus='DETENIDO'
                    break;
                case 'C': //cancelado por credito y cobranza
                    estatus='DETENIDO'
                    break;
                case 'PP': //procesando pedido
                    estatus='VALIDANDO CONDICIONES' //validando condiciones
                    break;
                case 'L': //listo para surtin
                    estatus='SURTIENDOSE' //surtiendose
                    break;
                case 'S': //surtiendose
                    estatus='SURTIENDOSE' //surtiendose
                    break;
                case 'SS': //suertiendose en sucursal
                    estatus='SURTIENDOSE' //surtiendose
                    break;
                case 'A': //aduanando
                    estatus='EMPACANDOSE'//empacandose
                    break;
                case 'E': //empacando
                    estatus='EMPACANDOSE' //empacandose
                    break;
                case 'M': //empacado listo para embarque
                    estatus='LISTO PARA ENVIAR' //empacandose
                    break;
                case 'B': //embarcado
                    estatus='ENVIADO' //enviado
                    break;
                default:
                    estatus='...'
                    break;
                }

                return estatus
            },
            estatus(e){
                var estatus=0
                
                switch (e) {
                case 'R': //recibido
                    estatus=1 //en revision
                    break;
                case 'D': //detenido
                    estatus=1 //en revision
                    break;
                case 'DP': //detenido por precio especial
                    estatus=1 //en revision
                    break;
                case 'DC': //detenido credito a un dia
                    estatus=1 //en revision
                    break;
                case 'DL': //detenido limite de credito
                    estatus=1 //en revision
                    break;
                case 'DS': //detenido saldo vencido
                    estatus=1 //en revision
                    break;
                case 'DD': //detenido cheque devuelto
                    estatus=1 //en revision
                    break;
                case 'DA': //detenido agrupacion
                    estatus=1 //en revision
                    break;
                case 'N': //no autorizado
                    estatus=2 //detenido
                    break;
                case 'C': //no autorizado
                    estatus=2 //detenido
                    break;
                case 'PP': //procesando pedido
                    estatus=3 //validando condiciones
                    break;
                case 'L': //listo para surtin
                    estatus=4 //surtiendose
                    break;
                case 'S': //surtiendose
                    estatus=4 //surtiendose
                    break;
                case 'SS': //suertiendose en sucursal
                    estatus=4 //surtiendose
                    break;
                case 'A': //aduanando
                    estatus=5 //empacandose
                    break;
                case 'E': //empacando
                    estatus=5 //empacandose
                    break;
                case 'M': //empacado listo para embarque
                    estatus=6 //empacandose
                    break;
                case 'B': //embarcado
                    estatus=7 //enviado
                    break;
                default:
                    estatus=0
                    break;
                }

                return estatus
            },
			async inicializar() {
				// var d = new Date()
                // var fechaInicial = d.getTime()-(30*24*60*60*1000) //fecha actual menos 30 dias
                // this.fechaInicio = fechaInicial
                
                this.paginaActual = 1
                var d = new Date()
                d.setDate(d.getDate()-30)
				this.fechaInicio = d
				this.fechaInicio = new Date(d.getFullYear(), d.getMonth(), d.getDate())
			},
			async pedidosActivosCon() {
                let result = await servicio.getPedidosActivos()
                if(result.value){
                    this.pedidosActivos = result.data
                }
                else {
                    this.pedidosActivos = []
                }
			},
		}
	}
</script>
<style scoped lang="scss">
    .rows {
        border-top: solid 4px var(--color-azul);
    }
    .fuente-texto{
        font-size: 20px;
    }
    .font18{
        font-size: 18px;;
    }
    .sinbordes{
        border-right: 0px !important;
        border-left: 0px !important;
    }
    .fuentesm{
        font-size: 10px;
    }
    .fuenteestatussm{
        font-size: 12px!important;
    }
    .tamano-icono{
        width: 25px;
		height: 25px;
    }
    .seleccionado-signo{
        position: relative;
		top: 0;
		z-index: 1; 
        font-size: 18px;
    }
    .badge-signo-sm{
        top: 0.1rem;
        right: -1.1rem;
        z-index: -1;
        position: absolute;
        font-size: 14px;
        background-color: white;
        color: var(--color-azul);
        border-radius: 5em; 
    }
    .badge-signo{
        top: 0.3rem;
        right: -1.1rem;
        z-index: -1;
        position: absolute;
        font-size: 14px;
        background-color: white;
        color: var(--color-azul);
        border-radius: 5em; 
        
    }
    .circulo{
        font-size: 27px;
        border-radius: 5em; 
        color: white;
    }
    .cabecera-tabla {
		background-color: #b6dff1;
	}
    .color-azul {
		color: #273c6e;
	}
    .table, td{
        cursor: pointer;
    }
    .cabecera-bg {
		background-color: #273c6e;
	}
    .ocultar{
        background: #ebebeb;
        border-color: #ebebeb
    }
	.ColorAzul {
		color: var(--color-azul);
	}
    .ButtonConsultar:hover {
        background: var(--color-azul);
        color: white;
    }
    .ButtonConsultar {
        width: 100%;
        height: 30px;
        border: 1px solid var(--bg-menu-blue);
        border-radius: 5px;
    }
    .tabla-activos {
		background-color: var(--color-azul) !important;
    }
    .etiqueta-pedidos{
		color: var(--color-azul) !important;
        font-size: 18px;
        font-weight: bold;
    }
    /* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
        .etiqueta-fecha{
            color: var(--color-azul) !important;
            font-size: 15px;
        }
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
        .etiqueta-fecha{
            color: var(--color-azul) !important;
            font-size: 15px;
        }
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
        .etiqueta-fecha{
            color: var(--color-azul) !important;
            font-size: 15px;
        }
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
        .etiqueta-fecha{
            color: var(--color-azul) !important;
            font-size: 15px;
        }

        .fuente-tablas{
            font-size: 11px;;
        }

        .fuente-texto{
            font-size: 16px;
        }

        .tamano-icono{
            width: 20px;
            height: 20px;
        }
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
        .etiqueta-fecha{
            color: var(--color-azul) !important;
            font-size: 15px;
        }
        .estatus{
            font-size: 18px;
            color: #5acf4f;
            font-weight: bold;
        }

        .fuente-tablas{
            font-size: 15px;;
        }

        .fuente-texto{
            font-size: 20px;
        }
        
        .tamano-icono{
            width: 25px;
            height: 25px;
        }
	}
</style>